import React from 'react'
import Text from './text/Text'
import Video from './video/Video'
import VisibleAsk from './ask/VisibleAsk'
import VisiblePause from './pause/Pause'
import Image from './image/Image'
import Geo from './geo/Geo'
import Plot from './plot/Plot'
import './interactiveContentBlocks.css'

const typeToComponent = {
  'text': Text,
  'video': Video,
  'ask': VisibleAsk,
  'pause': VisiblePause,
  'image': Image,
  'geo': Geo,
  'plot': Plot,
}

const InteractiveContentBlocks = ({content, type, id, as, disabled}) => {
  let shouldStop = false
  return (
    <div className='interactive-content-blocks'>
      {
        content.map((block, index)=>{
          if (!shouldStop) {
            if (Object.prototype.hasOwnProperty.call(typeToComponent, block.type)) {
              if ((block.type === 'ask' || block.type === 'pause') && !block.content.shouldContinue) {
                shouldStop = true
              }
              const TypeComponent = typeToComponent[block.type]
              return (
                <TypeComponent
                  key={block._id 
                    ? block._id 
                    : String(Math.random()).split('.')[1]
                  }
                  className='interactive-content-blocks__block'
                  content={block.content}
                  index={index}
                  type={type}
                  disabled={disabled}
                  as={as}
                />
              )
            }
            return null
          } else {
            return null
          }
        })
      }
    </div>
  )
}

export default InteractiveContentBlocks



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/InteractiveContentBlocks.js